import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holding-history',
  templateUrl: './holding-history.component.html',
  styleUrls: ['./holding-history.component.scss']
})
export class HoldingHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
